

import { faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Typography, useTheme } from '@mui/material';
import { FC, useContext } from 'react';

import MapFormContext from '../../contexts/data/MapFormContext';
import Center from '../common/Center';
import MapContext, { MapFilterSubmitter } from '../../contexts/data/MapContext';


const FormButton: FC = () => {

    // 
    // -- Hooks --
    const theme = useTheme();

    // 
    // -- Contexts --
    const { openDrawer, maximiseDrawer } = useContext(MapFormContext);
    const { filter, setSubmitterFilter } = useContext(MapContext);

    const handleClick = () => {
        if (filter.bySubmitter.submitter != MapFilterSubmitter.MyData) {
            setSubmitterFilter(c => ({
                ...c,
                prevState: filter.bySubmitter, 
                submitter: MapFilterSubmitter.MyData,
                submitterLabel: MapFilterSubmitter.toString(Number(MapFilterSubmitter.MyData))
            }));
        }
        openDrawer();
        maximiseDrawer();
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                backgroundColor: 'white',
                overflow: 'hidden',
                height: '40px',
                borderRadius: '15px',
                boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 4px -1px',

                "&:hover": {
                    cursor: 'pointer',
                    boxShadow: '0px 0px 6px 1px rgba(75,90,35,0.5)'
                }
            }}
            onClick={handleClick}
        >
            <Center
                sx={{ 
                    backgroundColor: theme.palette.primary.main,
                    padding: '15px',
                }}
            >
                <FontAwesomeIcon color='white' fontSize='1.8rem' icon={faCirclePlus} />
            </Center>
            <Center
                sx={{
                    padding: '15px',
                    display: 'none', 
                    [theme.breakpoints.up(400)]: {
                        display: 'flex'
                    } 
                }}  
            >
                <Typography fontWeight={600} variant='body1' sx={{ textWrap: 'nowrap' }}>Record Data</Typography>
            </Center>
        </Box>
    )
}

export default FormButton